export const defaultFieldType = { label: 'Select a Type', value: '-1', formatsList: [] }
export const defaultFormat = { label: 'Select a Format', value: '-1' }
